import { ErrorResponse, ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import { JobCategory } from '../types'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import qs from 'query-string'
export const getJobCategories = async (payload: DataGridPayload) => {
    const response = await datacentral.get<ResponseArray<JobCategory>>(
        `/job-categories?${qs.stringify(payload)}`
    )
    return response?.data
}

export const getJobCategory = async (id: number) => {
    const response = await datacentral.get<ResponseObject<JobCategory>>(
        `/job-categories/${id}`
    )
    return response?.data
}

export const createJobCategory = async (
    payload: JobCategory
): Promise<ResponseObject<JobCategory> | ErrorResponse> => {
    const response = await datacentral.post(`/job-categories`, payload)
    return response?.data
}

export const updateJobCategory = async (payload: {
    id: number
    jobCategory: JobCategory
}): Promise<ResponseObject<JobCategory> | ErrorResponse> => {
    const response = await datacentral.put(
        `/job-categories/${payload.id}`,
        payload.jobCategory
    )
    return response?.data
}

export const deleteJobCategory = async (
    id: number
): Promise<ResponseObject<JobCategory> | ErrorResponse> => {
    const response = await datacentral.delete(`/job-categories/${id}`)
    return response?.data
}
